import React from 'react';

export default function About() {
  return (
    <div className='d-flex h-100 text-center text-white bg-dark'>
      <div className='cover-container d-flex w-100 h-100 p-3 mx-auto flex-column'>
        <main className='px-3'>
          <h1>About page</h1> <br />
          <p className='lead'>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit sapiente unde omnis sequi! Sit
            dolores non reprehenderit ducimus saepe ipsa quae, ipsum commodi voluptas praesentium necessitatibus. Nulla
            nihil tempora eligendi? Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam a ex vero adipisci
            reprehenderit. Odio, a beatae dolores exercitationem asperiores veritatis quod tempore at repellat aliquid
            aliquam suscipit doloremque in?
          </p>
          <p className='lead'>
            <button className='btn btn-lg btn-secondary fw-bold border-white bg-dark'>Learn more</button>
          </p>
        </main>
      </div>
    </div>
  );
}
